import { render } from "./ClientAbonements.vue?vue&type=template&id=380b5f28&scoped=true"
import script from "./ClientAbonements.vue?vue&type=script&lang=js"
export * from "./ClientAbonements.vue?vue&type=script&lang=js"

import "./ClientAbonements.vue?vue&type=style&index=0&id=380b5f28&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-380b5f28"]])

export default __exports__